<template>
  <div class="login-dialog">
    <el-button
      v-if="!autoTenantEnable && !isLogin"
      class="tenant-trigger"
      @click="showLesseeDialog = true"
    >
      {{ obj.name }}
    </el-button>
    <el-dialog
     title="切换租户"
     :visible.sync="showLesseeDialog"
     @close="handleClose"
     width="460px"
    >
      <div class="login-box">
        <div class="list">
          <div
            :class="item.isYes ? 'item active' : 'item'"
            v-for="(item,index) in list"
            :key="index"
            @click="handleClick(item)"
          >
            <div>{{item.name}}</div>
          </div>
        </div>

        <div slot="footer" class="" style="display: flex;justify-content: flex-end;margin-top: 20px;">
          <el-button class="form-btn btn-gray" @click="showLesseeDialog = false">取消</el-button>
          <el-button class="form-btn btn-blue" @click="handleSave()">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";

export default {
  name: "login-dialog",
  data(){
    return{
      showLesseeDialog: false,
      autoTenantEnable: process.env.VUE_APP_AUTO_TENANT === 'true',
      list: [],
      obj: {},
      tenant: null,
    }
  },
  computed: {
    isLogin() {
      return this.$store.state.isLogin;
    }
  },
  async beforeMount() {
    this.tenant = window.sessionStorage.getItem('tenant-id')
    await this.getData();
    // 如果启用了自动租户选择，则执行自动匹配
    if (process.env.VUE_APP_AUTO_TENANT === 'true') {
      this.handleAutoTenant();
    }
    this.initTenantConfig();
  },
  methods: {
    async getData(){
      const res = await axios.get(`/admin/tenant/list?type=2`, { baseURL: process.env.VUE_APP_BASE_DOMAIN, headers: { skipToken: true} })
      this.list = res.data.data.map(item => {
        if (item.id === this.tenant) {
          this.obj = item
        }
        return{ ...item, isYes: item.id === this.tenant, }
      })
      if (!(this.obj && this.obj.id)) {
        this.obj = { name: '切换商户' }
      }
    },
    handleClick(row) {
      this.list.forEach(item => {
        item.isYes = false;
      })
      row.isYes = true;
      this.obj = row;
      this.handleCommand(row);
    },
    handleSave(){
      this.showLesseeDialog = false;
      window.location.reload();
    },
    handleClose () {
      this.showLesseeDialog = false
    },
    handleAutoTenant() {
      const domain = window.location.host;
      const matchedTenant = this.list.find((tenant) => !!tenant.tenantDomain && domain === tenant.tenantDomain);

      if (matchedTenant && this.tenant !== matchedTenant.id) {
        this.handleCommand(matchedTenant);
      }
    },

    handleCommand(tenant) {
      window.sessionStorage.setItem('tenant-id', tenant.id);
      this.handleSave();
    },

    initTenantConfig() {
      const currentTenant = this.list.find((item) => item.isYes);
      if (currentTenant) {
        // 移除现有的 favicon
        const existingFavicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
        if (existingFavicon) {
          existingFavicon.remove();
        }
        // window.sessionStorage.setItem('sh-logo', '');
        //
        window.sessionStorage.setItem('pageShTitle', currentTenant.name)
        // window.sessionStorage.setItem('baImg', currentTenant.background ? process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.background : '')
        // window.sessionStorage.setItem('sh-favicon', process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.favicon)
        // window.sessionStorage.setItem('sh-logo', process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.logo)
        // 创建新的 favicon
        const newFavicon = document.createElement('link');
        newFavicon.rel = 'icon';
        newFavicon.href = process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.favicon;
        newFavicon.type = 'image/png';
        document.head.appendChild(newFavicon);
        window.localStorage.setItem('sh-favicon', newFavicon.href)

        // 使用 Vuex 更新租户配置
        this.$store.commit('updateTenantConfig', {
          tenant: currentTenant.id,
          baImg: currentTenant.background ? process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.background : '',
          name: currentTenant.name,
          logo: currentTenant.logo ? process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.logo : '',
          titleImg: currentTenant.titleImg ? process.env.VUE_APP_BASE_IMG_HEADER + currentTenant.titleImg : ''
        })
      }
    }
  }
}
</script>

<style scoped lang="less">
.login-dialog{
  .login-box{
    .list{
      display: flex;
      align-items: center;
      justify-content: space-between;
      flex-wrap: wrap;
      .item{
        width: 49%;
        padding: 16px;
        border: 1px solid #ddd;
        border-radius: 4px;
        cursor: pointer;
        &.active{
          border: 1px solid #1481d1;
        }
      }
    }
  }
  .tenant-trigger {
    position: absolute;
    top: 30px;
    right: 170px;
    z-index: 10;
    min-width: 108px;
    height: 38px;
    padding: 0 12px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background: rgba(255, 255, 255, 0.95);
    border: 1px solid #e5e8ef;
    border-radius: 6px;
    box-shadow: 0 8px 24px rgba(29, 55, 93, 0.08);
    color: #2f3a4f;
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    transition: border-color 0.2s, box-shadow 0.2s;

    &:hover {
      border-color: #c8d5ee;
      color: #2f3a4f;
      background: rgba(255, 255, 255, 0.95);
      box-shadow: 0 10px 28px rgba(29, 55, 93, 0.12);
    }
  }
  ::v-deep .el-dialog__body{
    padding: 10px 20px 20px 20px !important;
  }
}
.register_form{
  span{
    margin-left: 5px;
    cursor: pointer;
  }
}
</style>